import { createBroker } from 'broker-factory';
export const wrap = createBroker({
    allocate: ({ call }) => {
        return async (length) => {
            return call('allocate', { length });
        };
    },
    deallocate: ({ notify }) => {
        return (arrayBuffer) => {
            notify('deallocate', { arrayBuffer }, [arrayBuffer]);
        };
    }
});
export const load = (url) => {
    const worker = new Worker(url);
    return wrap(worker);
};
//# sourceMappingURL=/build/es2018/module.js.map